import React from "react";
import { ReactComponent as Logo } from "@assets/logo.svg";

interface Props {
  className?: string;
  height?: number;
}

export default ({ className, height }: Props) => <Logo width="100%" height={height ?? 16} className={className} />;
